import {
  FilterMode,
  TenantStatusCreateMutationVariables,
  TenantStatus_OrderBy,
  TenantStatus,
  SortOrder,
  TenantStatus_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const tenantStatusService = {
  createOne: buildCreateOne(
    (tenantStatusCreateVariables: TenantStatusCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.tenantStatusCreate(
          tenantStatusCreateVariables
        );
        return result.tenantStatusCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantStatusOne({ id });
    return result.tenantStatusOne as TenantStatus;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TenantStatus_OrderBy[] | null = null,
    filter: TenantStatus_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantStatus_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantStatusListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantStatusListWithOffset
    ) as TenantStatus[];
    return { list, orderBy };
  },
};
